<ng-container *cbWaitFor="lotMappedItem$$ | async">
    @if (!selectedPreConsentPlan) {
        <form #designSchemeCardForm="ngForm" class="manage-preconsent-container">
            <mat-card class="start-end flex-row" *cbWaitFor="lotMappedItem$$ | async">
                <mat-card-content class="mat-card-content-row">
                    <span class="flex"> </span>
                    @if (canGeneratePreConsent()) {
                        <cb-button
                            [disabled]="!canGeneratePreconsentValueFromApi"
                            (clicked)="generatePreConsent()"
                            (popupClick)="goToLotSpecification()"
                            style="z-index: 1"
                            [popup]="{
                                description: preconsentBlockingReason,
                                buttonText: lotSpecHasIncompleteItems
                                    ? 'Go to Lot Specification'
                                    : '',
                                disabled: lotSpecHasIncompleteItems,
                                buttonIsHidden: !lotSpecHasIncompleteItems
                            }"
                        >
                            Request Pre-consent
                        </cb-button>
                    }
                    @if (canCreatePreConsent()) {
                        <cb-button
                            [disabled]="isCreatePreConsentDisabled()"
                            [ngClass]="
                                !canGeneratePreconsentValueFromApi
                                    ? 'cb-margin-left-4x'
                                    : 'cb-margin-left-2x'
                            "
                            color="primary"
                            (clicked)="createPreConsentPlan()"
                        >
                            Create Pre-Consent Plan
                        </cb-button>
                    }
                </mat-card-content>
            </mat-card>
            <div class="flex-row">
                <div class="flex-wrap">
                    @for (plan of mappedItem?.preConsentPlans; track plan) {
                        <cb-pre-consent-card
                            class="flex-col"
                            [lotMappedItem]="lotMappedItem"
                            (lotMappedItemChange)="notifyLotMappedItemChanged()"
                            [preConsentPlan]="plan"
                            (viewPreConsentClicked)="handleViewPreConsent($event)"
                        >
                        </cb-pre-consent-card>
                    }
                </div>
            </div>
        </form>
    }
    @if (selectedPreConsentPlan) {
        <cb-manage-pre-consent-view
            (goBack)="handleGoBack()"
            [mappedItem]="selectedPreConsentPlan"
            [lotMappedItem]="lotMappedItem"
        >
        </cb-manage-pre-consent-view>
    }
</ng-container>
